var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaOnlineshop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#40596b;}.cls-3{fill:#fff;}.cls-4{fill:#cdd6e0;}.cls-5{fill:#f2f2f2;}.cls-6{fill:#acb3ba;}.cls-7{fill:#ffd15c;}.cls-8{fill:#f8b64c;}.cls-9{fill:#ff7058;}.cls-10{fill:#e4eaef;}.cls-11{fill:#f1543f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146,30.5H14a6,6,0,0,0-6,6v89.4a6,6,0,0,0,6,6H146a6,6,0,0,0,6-6V36.5A6,6,0,0,0,146,30.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.95,
    y: 39.5,
    width: 126,
    height: 83.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 52.35,
    y: 131.9,
    width: 54.9,
    height: 16.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 35.85,
    y: 148.1,
    width: 88.2,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 52.35,
    y: 131.9,
    width: 54.9,
    height: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M132.15,41.6v76.2a4.74,4.74,0,0,1-4.8,4.8H32.25a4.74,4.74,0,0,1-4.8-4.8V41.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.55,62.9V74.3h-1.2V62.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.55,106.7v11.4h-1.2V106.7h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.75,71.3l-8.1,8.1-.9-.9,8.1-8.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68.85,102.5l-8.1,8.1-.9-.9,8.1-8.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.55,89.9v1.2H96.45V89.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.75,90.5v.6H52.65V89.9h11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.75,109.4l-.9.9-7.8-7.8.9-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68.85,78.5l-.9.9-8.1-8.1.9-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.25,75.2c-.3,0-.6.3-1.2.6l-2.7-6.3,1.2-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.25,111.8l-1.2.6-2.7-6.3c.3,0,.6-.3,1.2-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.25,83.6c-.3.3-.3.6-.6,1.2l-6.3-2.7.6-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.55,98.9l-.6,1.2-6.3-2.7c.3-.3.3-.6.6-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.25,97.1,59,99.8l-.6-1.2,6.3-2.7C65,96.5,65,96.8,65.25,97.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.55,82.1l-6.3,2.7c0-.3-.3-.6-.6-1.2l6.3-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.25,105.8l-2.7,6.3-1.2-.6,2.7-6.3C73.65,105.5,74,105.5,74.25,105.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.25,69.2l-2.4,6.3c-.3-.3-.6-.3-1.2-.6l2.7-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M126.15,8H33.75a6,6,0,0,0-6,6V29.6h104.7V14A6.49,6.49,0,0,0,126.15,8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "101.25 86.6 106.95 107 112.05 101.9 116.85 107 121.35 102.5 116.55 97.4 121.35 92.3 101.25 86.6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 67.05,
    cy: 18.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 53.25,
    cy: 18.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 39.45,
    cy: 18.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M132.15,44V58.1a10.22,10.22,0,0,1-6.6,2.1,11.39,11.39,0,0,1-11.4-11.4,11.4,11.4,0,1,1-22.8,0,11.4,11.4,0,1,1-22.8,0,11.4,11.4,0,0,1-22.8,0,11.39,11.39,0,0,1-11.4,11.4,12.31,12.31,0,0,1-6.6-2.1V44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "45.75 41.6 22.95 41.6 27.75 29.6 48.45 29.6 45.75 41.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "68.55 41.6 45.75 41.6 48.45 29.6 69.45 29.6 68.55 41.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "91.35 41.6 68.55 41.6 69.45 29.6 90.45 29.6 91.35 41.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "114.15 41.6 91.35 41.6 90.45 29.6 111.45 29.6 114.15 41.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "136.95 41.6 114.15 41.6 111.45 29.6 132.15 29.6 136.95 41.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.75,46.7a11.4,11.4,0,1,0,22.8,0V41.6H45.75v5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.35,41.6v5.1a11.4,11.4,0,0,0,22.8,0V41.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M23,46.7a11.4,11.4,0,1,0,22.8,0V41.6H23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M68.55,46.7a11.4,11.4,0,1,0,22.8,0V41.6H68.55v5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M114.15,41.6v5.1a11.4,11.4,0,0,0,22.8,0V41.6Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 79.95,
    cy: 90.5,
    rx: 17.7,
    ry: 18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77,95.9l-.6-2.1h13.8V83.3H73.65l-.9-3.9H68v1.8h3.6l4.2,16.5h15V95.9Zm11.4-11.1v6.9H76.05l-1.8-6.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 79.65,
    cy: 101,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 87.45,
    cy: 101,
    r: 2.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaOnlineshop);
export default __webpack_public_path__ + "static/media/ka_onlineshop.9250759c4b92c9b0acdf3dce9687c35e.svg";
export { ForwardRef as ReactComponent };